import { memo } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '../../../components/Button';
import DeleteButton from '../../../components/DeleteButton';
import { pagesText } from '../../../constants/pagesText';
import ConditionComponent from '../../../components/ConditionComponent';

const SettingsActions = ({
  onCancel,
  onDelete,
  isEditMode,
  isSubmitDisabled = false,
  // Cancel closes/discards rather than saves, so an untouched (non-dirty) form shouldn't grey it
  // out the way it does Save - only disable it while a submit is actually in flight.
  isCancelDisabled = false,
  SecondaryButtonComponent,
  // GeneralTextField reserves a 70px accessory slot to its right by default, so this margin
  // normally lines the buttons up with that field's visible (shrunk) edge rather than the
  // container's true edge. Pass noOffset when there's no such field (e.g. this sits alongside a
  // fullWidth field with no accessory slot, as in a dialog) so the buttons align flush right.
  noOffset = false,
}) => (
  <Stack direction="row" justifyContent="space-between">
    {isEditMode ? (
      <DeleteButton onClick={onDelete}>{pagesText.deleteEnvironmentButton}</DeleteButton>
    ) : (
      <Box />
    )}
    <Stack
      direction="row"
      justifyContent="end"
      gap={1.75}
      sx={{
        marginRight: noOffset ? 0 : 9.5,
      }}>
      <ConditionComponent
        condition={!!SecondaryButtonComponent}
        renderElement={SecondaryButtonComponent}
      />
      <Button
        disabled={isCancelDisabled}
        variant="text"
        onClick={onCancel}
        styles={{
          color: '#B5B5B5',
          textTransform: 'capitalize',
        }}>
        Cancel
      </Button>
      <Button
        disabled={isSubmitDisabled}
        variant="outlined"
        type="submit"
        styles={{
          textTransform: 'capitalize',
        }}>
        Save
      </Button>
    </Stack>
  </Stack>
);

export default memo(SettingsActions);
